/**
 * Whether `text` names `phrase` as whole words, ignoring case and spacing: market
 * "US" is not in "business", and business "Spa" is not in "spacious". A raw
 * substring check gave false greens in the health line and false refusals in the
 * question editor (Jack, #4287).
 */
export function containsPhrase(text: string, phrase: string): boolean {
    const words = phrase.trim().split(/\s+/).filter(Boolean);
    if (!words.length) return false;
    const escaped = words.map((word) => word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")).join("\\s+");
    return new RegExp(`(?:^|[^\\p{L}\\p{N}])${escaped}(?=$|[^\\p{L}\\p{N}])`, "iu").test(text);
}
